var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33 3.254c-.274 0-.578.36-.578.839V5.76H8.64l-.437 2.378H5.752v7.137H3.027V8.138H.555V5.76h2.472V4.362C3.027 2.355 4.42.725 6.33.725h2.308v2.53H6.33z",
    fill: "#1C2025",
    fillRule: "nonzero"
  })));
};
export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02LjMzIDMuMjU0Yy0uMjc0IDAtLjU3OC4zNi0uNTc4LjgzOVY1Ljc2SDguNjRsLS40MzcgMi4zNzhINS43NTJ2Ny4xMzdIMy4wMjdWOC4xMzhILjU1NVY1Ljc2aDIuNDcyVjQuMzYyQzMuMDI3IDIuMzU1IDQuNDIuNzI1IDYuMzMuNzI1aDIuMzA4djIuNTNINi4zM3oiCiAgICAgICAgICBmaWxsPSIjMUMyMDI1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz4KPC9zdmc+'";